import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
// import Clipboard from 'v-clipboard'
// import { Vue2Dragula } from 'vue2-dragula'
import App from './App'
import store from './store'
import { router, checkRoute } from './router'
import { forEach } from './views/utils'
import * as filters from './views/utils/filters'
import { components } from './views/components/globals'
import { attachVue } from './bugsnag'
import './modernizr'

// global filters
forEach(filters, (filter, name) => Vue.filter(name, filter))

// global components
forEach(components, (component, tag) => Vue.component(tag, component))

// local storage
Vue.use(VueLocalStorage)

// clipboard management
// Vue.use(Clipboard)

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
})

attachVue(Vue)

// Vue.use(Vue2Dragula, {
//   logging: {
//     service: true,
//   },
// })

export { app, checkRoute as check }



// WEBPACK FOOTER //
// ./src/main.js